import { Icon, useTheme } from '@salecycle/ui-component-library';
import { Handle } from '../Canvas';

import { WorkflowBox } from '../WorkflowBox/WorkflowBox';
import { TooltipWithTitle } from 'components/experimental/TooltipWithTitle';

export function EndOfFlowNode() {
  const theme = useTheme();
  return (
    <WorkflowBox id="EndOfFlow" style={{ width: 'auto', padding: '8px 16px', color: theme.vars.newColor.darkGS2 }}>
      <Handle type="target" position={'top' as any} />
      <div style={{ display: 'flex', alignItems: 'center', margin: 0, position: 'relative' }}>
        <p style={{ margin: 0, marginRight: '1rem' }}>END OF FLOW</p>
        <TooltipWithTitle content="When a website visitor reaches the end of a campaign flow, they will exit the campaign until they re-match the trigger conditions.">
          <Icon icon="info-circle" />
        </TooltipWithTitle>
      </div>
    </WorkflowBox>
  );
}
